import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();


const video = document.getElementById('bg-video') as HTMLVideoElement;

if (video) {
  video.onerror = () => {
    document.body.style.background = '#1b1f22';
  };
}

